import { ReactNode, useState } from "react";
import { Button } from "@/components/catalyst/button";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { AlertDialog } from "@/lib/Components/Dialog/AlertDialog";
import {
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "@/components/catalyst/alert";

export type ConfirmDeleteDialogProps = {
  title: ReactNode;
  message: ReactNode;
  buttonText?: ReactNode;
  children?: ReactNode;
  onDelete: () => Promise<any> | any;
};

export function ConfirmDeleteDialog({
  onDelete,
  title,
  message,
  buttonText = "Delete",
  children,
}: ConfirmDeleteDialogProps) {
  const { close, resolve, reject } = useDialogState();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <AlertDialog
      onClose={() => {
        reject?.(false);
      }}
    >
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{message}</AlertDescription>
      {children}
      <AlertActions>
        <Button
          outline
          onClick={() => {
            close();
            reject?.(false);
          }}
        >
          Cancel
        </Button>
        <Button
          color="red"
          isLoading={isLoading}
          onClick={async () => {
            try {
              setIsLoading(true);
              await onDelete();
              await close();
              resolve?.(true);
            } catch (e) {
              throw e;
            } finally {
              setIsLoading(false);
            }
          }}
        >
          {buttonText}
        </Button>
      </AlertActions>
    </AlertDialog>
  );
}
